import { render, staticRenderFns } from "./DriverFileModal.vue?vue&type=template&id=1947d412&scoped=true"
import script from "./DriverFileModal.vue?vue&type=script&lang=js"
export * from "./DriverFileModal.vue?vue&type=script&lang=js"
import style0 from "./DriverFileModal.vue?vue&type=style&index=0&id=1947d412&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1947d412",
  null
  
)

export default component.exports